import React from "react";
import { ShieldCheck, ClipboardList, Users2, CalendarClock } from "lucide-react";

const POINTS = [
  {
    icon: ShieldCheck,
    title: "Standartlara uygun yaklaşım",
    body: "Saha ölçümü ve değerlendirme süreçlerinde ISO 10816 / 20816 yaklaşımı esas alınır.",
  },
  {
    icon: ClipboardList,
    title: "Teknik raporlama",
    body: "Her hizmette önceliklendirilmiş aksiyonlar içeren, anlaşılır PDF teknik rapor teslim edilir.",
  },
  {
    icon: Users2,
    title: "Saha + analiz + rapor",
    body: "Kendi saha ekibimiz ve ihtiyaca göre çözüm ağımızla; ölçüm, uygulama ve raporlamayı uçtan uca yürütüyoruz.",
  },
  {
    icon: CalendarClock,
    title: "Periyodik bakım programı",
    body: "Kritiklik bazlı periyodik bakım programları ile plansız duruş riskini azaltmaya yönelik yapılandırma.",
  },
];

export default function WhyDatavib() {
  return (
    <section
      data-testid="why-section"
      className="bg-white py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Left intro */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <span className="divider-tick"></span>
              <span className="overline">NEDEN DATAVIB?</span>
            </div>
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight leading-[1.1]"
              style={{ fontFamily: "Outfit" }}
            >
              Sahada hızlı çözüm,
              <br />
              <span className="text-cyan-600">teknik raporda netlik.</span>
            </h2>
            <p className="mt-6 text-slate-600 leading-relaxed">
              DATAVIB, fabrikanızdaki kritik ekipmanlar için yalnızca ölçüm değil;
              ölçüm + uygulama + raporlamayı saha ekibi ve gerektiğinde çözüm
              ortaklarıyla birlikte yürütür. Bu yaklaşım, arıza süresini kısaltma
              ve planlı bakımı gerçekçi şekilde yönetme hedefini destekler.
            </p>
          </div>

          {/* Right grid */}
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-slate-200">
            {POINTS.map((p, i) => {
              const Icon = p.icon;
              return (
                <div
                  key={i}
                  data-testid={`why-card-${i + 1}`}
                  className="bg-white p-7 lg:p-8 hover:bg-slate-50 transition-colors group"
                >
                  <div className="w-11 h-11 grid place-items-center bg-cyan-50 border border-cyan-100 group-hover:bg-cyan-600 group-hover:border-cyan-600 transition-colors rounded-sm mb-5">
                    <Icon className="w-5 h-5 text-cyan-600 group-hover:text-white" strokeWidth={1.5} />
                  </div>
                  <h3
                    className="text-lg font-bold text-slate-900 mb-2"
                    style={{ fontFamily: "Outfit" }}
                  >
                    {p.title}
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed">{p.body}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
